import { Box } from '@material-ui/core'
import RadioControl from './controllers/RadioControl'
import SwitchControl from './controllers/SwitchControl'
import InputControl from './controllers/InputControl'
import CheckboxControl from './controllers/CheckboxControl'
const renderController = (attribute: any, itemKey: any, unitId: any) => {

    switch (attribute.data_type) {
        case 'select_one':
            return <RadioControl attribute={attribute} itemKey={itemKey} unitId={unitId} />
        case 'yes_no':
            return <SwitchControl attribute={attribute} itemKey={itemKey} unitId={unitId} />
        case 'input':
            return <InputControl attribute={attribute} itemKey={itemKey} unitId={unitId} />
        case 'select_multi':
            return <CheckboxControl attribute={attribute} itemKey={itemKey} unitId={unitId} />
        default: return null
    }
}

type QuestionAttributeType = {
    attribute: any,
    itemKey: any,
    unitId: any
}

export default function QuestionAttribute({ attribute, itemKey, unitId }: QuestionAttributeType) {
    return (
        <Box height="100%">
            {renderController(attribute, itemKey, unitId)}
        </Box>
    )
}
